<template>
  <cube-page title="部门销售">
    <div slot="content" style="background-color: white; margin-top:15px">
      <wmq-layout
        ref="detail"
        :rootLayoutConfig="rootLayoutConfig" />
    </div>
  </cube-page>
</template>

<script>
import uiConfig from '@/config/ui-config/dept-sales-detail-ui-config'
import { biData } from '@/api/cube'
import { CubeDataHandle, WmqDashboardCubeDataHelperMixin } from 'wmq-component'
import { get, set } from 'lodash'
import CubePage from '../../components/cube-page'
export default {
  name: 'DeptSales',
  components: { CubePage },
  mixins: [WmqDashboardCubeDataHelperMixin],
  computed: {
    rootLayoutConfig () {
      const height = document.body.clientHeight - 100
      set(uiConfig, 'schema.0.children.明细数据.layout.pos.h', height)
      return uiConfig
    }
  },
  mounted () {
    this.$refs['detail'].refreshAll()
  },
  provide () {
    const that = this
    return {
      requestHandler: function (data, reqObj) {
        if (get(reqObj, 'date') === '__date__') {
          reqObj.date = that.$route.query.date
        }
        reqObj.dept = that.$route.query.dept
        return biData(data.dataCode, reqObj).then(res => {
          return new Promise((resolve) => {
            resolve(CubeDataHandle.handleCubeData(res.data))
          })
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
